import Vue from 'vue'
// import './plugins/vuetify'
import App from './App.vue'
import store from './store'
import Vuetify from 'vuetify'
import 'vuetify/src/stylus/app.styl'

import VueRouter from 'vue-router';
Vue.use(VueRouter);

import VueResource from 'vue-resource';
Vue.use(VueResource);
Vue.http.options.emulateJSON = true;

import VueCookie from 'vue-cookie';
Vue.use(VueCookie);

import SecureImage from './components/SecureImage';
Vue.component('sec-img', SecureImage)

Vue.config.productionTip = false

Vue.prototype.$store = store;

import {setupI18n} from './locale';

import VueSignaturePad from 'vue-signature-pad';
Vue.use(VueSignaturePad);

export function setup(config, versions) {

  config.menu
    .filter(x => x.component instanceof Function)
    .forEach(x => Vue.component(x.name, x.component))

  config.topMenu
    .filter(x => x.component instanceof Function)
    .forEach(x => Vue.component(x.name, x.component))

  const routes = config.menu
    .map(({path, name, component}) => ({
      path: path || `/${name}`,
      name,
      component: component
    }));

  const customLocales = config.i18n && config.i18n.messages;
  const i18n = setupI18n(customLocales);

  function i18nFactory(original) {
    return function (label) {
      if (typeof label == 'object' && label !== null) {
        if (label.hasOwnProperty(i18n.locale)) {
          return label[i18n.locale];
        }

        if (label.hasOwnProperty('de')) {
          return label.de;
        }

        if (label.hasOwnProperty('en')) {
          return label.en;
        }

        return label[Object.keys(label)[0]];
      }

      return original.apply(this, arguments);
    }
  }

  i18n.t = i18nFactory(i18n.t);


  Vue.use(Vuetify, {
    options: {
      customProperties: true,
    },
    iconfont: 'md',
    lang: {
      t: (key, ...params) => i18n.t(key, params)
    },
    theme: config.colors || {}
  });

  new Vue({
    i18n,
    render: h => h(App),
    router: new VueRouter({
      routes // short for `routes: routes`
    }),
    data() {
      return {
        session: JSON.parse(localStorage.getItem('session') || sessionStorage.getItem('session') || '{}'),
        config,
        versions,
        authorizing: false,
      }
    },
    created() {
      if (this.$router.currentRoute.fullPath.match(/^\/tickets\/\d+\/.+$/gi) && !this.hasSession) {
        const [,,, tokenPart] = this.$router.currentRoute.fullPath.split('/');
        const [ID, token] = tokenPart.split(':') || '';
        if (ID && token) {
          this.session = {ID, token, entity: 'tickets'};
        }
      }

      Vue.prototype.$t = i18nFactory(Vue.prototype.$t);

      Vue.http.interceptors.push((request, next) => {
        request.headers.set('X-Auth', (this.session.entity || 'Bearer') + ' ' + this.sessionToken);

        next((response) => {
          if (response.status === 401) {
            this.clearSession();
            this.$router.push('/login')
          }
        });
      });

      document.title = config.documentTitle;

      if (this.$router.currentRoute.fullPath.match(/^\/basic-auth:.+$/gi)) {
        const [, tokenPart, localePart] = this.$router.currentRoute.fullPath.split(':');
        if (localePart) {
          const [locale] = localePart.split('-');
          if (Object.keys(i18n.messages).indexOf(locale) >=0) {
            i18n.locale = locale;
          }
        }

        const [username, password] = atob(tokenPart).split(':') || [];
        if (username && password) {
          this.authorizing = true;
          this.$http.post(this.$root.route('auth'), {username, password})
            .then(
              // Success
              response => {
                console.log('Session recovered');
                this.registerSession(response.body.result);
              },
              // Failure
              response => {
                // Session expired
                console.log('Session expired');
                this.clearSession();
              }
            );
          return
        }
      }

      this.loginPrefilled = {};
      if (this.$router.currentRoute.fullPath.startsWith('/login/')) {
        const [,, instance, login] = this.$router.currentRoute.fullPath.split('/');
        this.loginPrefilled = {
          instance,
          login,
        };

        this.$router.push('/login')
      }

      //Auto-login
      if (!this.hasSession) {
        this.$http.post(this.$root.route('auth'), {token: this.sessionToken})
          .then(
            // Success
            response => {
              console.log('Session recovered');
              this.registerSession(response.body.result);
            },
            // Failure
            response => {
              // Session expired
              console.log('Session expired');
              this.clearSession();
            }
          );
      }
    },

    computed: {
      hasSession() {
        return typeof this.session.token !== 'undefined';
      },
      sessionToken() {
        return this.session.ID && this.session.token ? this.session.ID + ':' + this.session.token : null;
      },
      avatar() {
        return (this.hasSession && typeof this.session.avatar === 'string') ? this.session.avatar : false;
      },
      globalComponent() {
        return this.$children[0]
      },
      canLogout() {
        return !this.session.entity;
      },
      isEmbedded() {
        return window.top !== window;
      },
      currentUser() {
        return this.session;
      }
    },

    methods: {
      visibleIcon(isPinVisible) {
        return isPinVisible
          ? require(`./assets/eye.svg`)
          : require(`./assets/eye-off.svg`);
      },
      registerSession(session, persist) {
        this.authorizing = false;
        this.session = session;
        console.log('session', session);

        localStorage.removeItem('session');
        sessionStorage.removeItem('session');
        if (persist) {
          localStorage.setItem('session', JSON.stringify(session));
        } else {
          sessionStorage.setItem('session', JSON.stringify(session));
        }
      },
      clearSession() {
        this.authorizing = false;
        localStorage.removeItem('session');
        sessionStorage.removeItem('session');
        this.session = {};
      },
      route(route) {
        const lang = ((this.$i18n.messages[this.$i18n.locale] || {}).Lang || {}).iso;
        return config.api.url + route + (route.indexOf('?') < 0 ? '?' : '&') + 'language=' + encodeURIComponent(lang);
      },
      canAccess(acl) {
        return this.hasSession && Object.keys(acl).every(key => this.session[key] === acl[key]);
      }
    }
  }).$mount('#app')
}
